import { PardotPicklistValue } from './PardotPicklistValue';
import React from 'react';
import { SearchFilterQueryParams } from '../filters';
import { useQueryResource } from '@hooks';
import { keyPaginationDefaultQueryParams, keyPaginationFallbackQueryParams } from '@ui/KeyPagination';
import {
	KeyPaginationQueryParams,
	PaginatedResource,
	PeriscopePardotPicklistValue
} from '@sonar-software/sonar-ts-types';
import { PeriscopeSearch, PeriscopeV3PaginatedList } from '..';

export interface PardotPicklistValueListProps {
	parentIndex: number;
	uri: string;
}

type QueryType = PaginatedResource<PeriscopePardotPicklistValue>;
export type PardotPicklistValueListQueryParams = KeyPaginationQueryParams & SearchFilterQueryParams;

const renderPicklistValue = (picklistValue: PeriscopePardotPicklistValue) =>
	<PardotPicklistValue
		key={ picklistValue.internalName }
		picklistValue={ picklistValue } />;
export const PardotPicklistValueList: React.FC<PardotPicklistValueListProps> = ({ uri }) => {
	const { loading, resource, queryParams, updateParams } = useQueryResource<
		QueryType,
		PardotPicklistValueListQueryParams
	>({
		defaultParams: keyPaginationDefaultQueryParams,
		fallbackParams: keyPaginationFallbackQueryParams,
		uri
	});

	return (
		<>
			<PeriscopeSearch onChange={ updateParams } />
			<PeriscopeV3PaginatedList
				loading={ loading }
				onChange={ updateParams }
				queryParams={ queryParams }
				renderListItem={ renderPicklistValue }
				resource={ resource } />
		</>
	);
};
